import React from 'react';
import { brand } from '../mock/data';

const items = ['16th Anniversary', 'Limited Release', 'The Lotus Tote', '20 Per Color', 'PL16'];

const Marquee = () => (
  <section className="relative border-y border-[var(--line)] bg-[var(--paper)] py-6 overflow-hidden">
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
          {items.map((t, i) => (
            <span key={i} className="flex items-center">
              <span className="font-display uppercase text-[clamp(1.6rem,4vw,3.2rem)] leading-none px-6 text-[var(--ink)]">{t}</span>
              <img src={brand.marks.lotus} alt="" className="h-6 w-auto opacity-80 mx-1" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);

export default Marquee;
